import * as ActionTypes from '../constants/ActionTypes'
import * as StepLabels from '../constants/StepLabels'
import {isClientDataStepValid, isPaymentSettingsValid} from "../selectors/StepValidation";
import {getStepOrder} from "../selectors/UserInterface";
import {deselectBaseArticle} from "./BaseArticle";

// **************************************************************************************************************
const selectLatestStep = () => (dispatch, getState) => {
    return dispatch({
        type: ActionTypes.STEP_SELECT_LATEST,
        payload: {
            state: getState()
        }
    });
}

export const selectStep = (stepSelected) => ({
    type: ActionTypes.STEP_SELECTED,
    goingTo: stepSelected
})

export const gotoNextStep = () => (dispatch, getState) => {

    const skipPaymentStep = getState().clientDataStep.existingCustomerSelected && getState().ui.currentStep === StepLabels.CLIENTDATA

    dispatch({
        type: ActionTypes.STEP_CONTROL_NEXT,
        payload: {
            skipPaymentStep: skipPaymentStep,
            state: getState()
        }
    })
}

export const gotoPrevStep = () => (dispatch, getState) => {

    if (getState().ui.currentStep === getStepOrder(getState())[0]) {

        dispatch(deselectBaseArticle())

    } else {

        const skipPaymentStep = getState().clientDataStep.existingCustomerSelected && getState().ui.currentStep === StepLabels.SUMMARY

        dispatch({
            type: ActionTypes.STEP_CONTROL_PREV,
            payload: {
                skipPaymentStep: skipPaymentStep,
                state: getState()
            }
        })

    }
}

export const forceValidationOnSteps = (steps) => ({
    type: ActionTypes.STEP_FORCE_VALIDATION,
    stepsToBeValidated: steps
})

export const selectLatestValidStep = () => (dispatch, getState) => {

    const stepsCompleted = getState().ui.stepsCompleted

    if (stepsCompleted.includes(StepLabels.CLIENTDATA) && !isClientDataStepValid(getState())) {

        dispatch(selectStep(StepLabels.CLIENTDATA))

    } else if (stepsCompleted.includes(StepLabels.PAYMENT) && !isPaymentSettingsValid(getState())) {

        dispatch(selectStep(StepLabels.PAYMENT))

    } else {

        dispatch(selectLatestStep())

    }

}


/** WEBPACK FOOTER **
 ** ./src/actions/StepControl.js
 **/